<template>
  <div class="info-message">
    <div class="inner">
      <span class="text"
            v-html="urlify(message)"
            :value="message">

      </span>

    </div>

  </div>

</template>

<script>
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import {bus} from '../../../main.js'

  // import VueContext from 'vue-context';
  // import 'vue-context/src/sass/vue-context.scss';
  // import TextareaEmojiPicker from '../../components/TextareaEmojiPicker.vue'
  import {Picker} from 'emoji-mart-vue'
  import {Emoji} from 'emoji-mart-vue'
  import Vue from 'vue'
  import InfiniteLoading from "vue-infinite-loading";

  export default {
    components: {
      InfiniteLoading,
      VueSlickCarousel,
      VuetifyAudio: () => import('vuetify-audio'),
      Emoji,
      Picker,
    },

    data() {
      return {}
    },
    props: {
      message: String,
      RecTypeId: Number,
      index: Number,
      IsSelected: Boolean,
      date_now: String
    },
    beforeDestroy() {
      bus.$off('signalr_methods', this.listener)
    },
    mounted() {
      // this.configRecording()

      // window.addEventListener('resize', this.resize_mobile, {passive: true})
      // this.resize_mobile()
    },

    watch: {},

    methods: {
      get_conversation_date(item) {
        var date = item.SubmitDateTimeMiladi
        date = date.replace('  ', ' ')
        var days = 0
        var dateNow = new Date(this.convert_string_to_date(this.date_now))
        var conv_date = new Date(this.convert_string_to_date(date))
        // var conv_date_hour2 = new Date(item.SubmitDateTime)

        var reportDate = item.SubmitDateTime.substring(11)
        // console.log(item)
          days = dateNow - conv_date

        days = days / (1000 * 60 * 60 * 24)

        var ret
        if (days < 1) {
          ret = reportDate
        // }
        // else if (days >= 1 && days < 2) {
        //   ret = ' دیروز ' + reportDate
        // } else if ((days < 8) && (days > 1)) {
        //   ret = days + ' روز قبل ' + reportDate
        } else {
          ret = item.SubmitDateTime
        }

        return ret
      },
      convert_string_to_date(date) {
        var dateString = date

        var reggie = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/
        var dateArray = reggie.exec(dateString)

        // var date = dateArray[3]+"-"+dateArray[2]+"-"+dateArray[1]+"T00:00:00.000+03:30"
        try {
          var dateObject = new Date(
            (+dateArray[3]),
            (+dateArray[2]), // Careful, month starts at 0!
            (+dateArray[1]),
            (+dateArray[4]),
            (+dateArray[5]),
            (+dateArray[5])
          )
          return dateObject.toDateString()
        } catch (e) {
          return ''
        }
      },
      openLink(type, link) {
        link = link.replace('http://chidl', 'https://chidl')
        if (type == 1) {
          console.log('link ', link)
          window.open(link, '_blank')
        }
        if (type == 6) {
          window.open(link, '_blank')
        }
        if (type == 2) {
          window.open(link, '_blank')
        }
        if (type == 4) {
          link = link.split('*')
          link = 'https://www.google.com/maps/search/?api=1&query=' + link
          window.open(link, '_blank')
        }
      },
      openImg(item) {
        this.dialog = true
        this.open_image = item
        console.log('open')
      },
      openMap(item) {
        window.open('https://www.google.com/maps?q=' + item.split('*')[0] + ',' + item.split('*')[1] + '&z=17&hl=en')
      },
      urlify(text) {
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function (url) {
          return '<a target="_blank" href="' + url + '">' + url + '</a>';
        })
        // or alternatively
        // return text.replace(urlRegex, '<a href="$1">$1</a>')
      },
    }
  }
</script>
<style lang="scss" scoped>
  .basemap {
    width: 100%;
    height: 500px;
  }
</style>
